module.exports = __webpack_public_path__ + "fonts/fontawesome-webfont.svg";


//////////////////
// WEBPACK FOOTER
// /Users/balazskaxd/dev/rkk/rkk-webapp/~/font-awesome/fonts/fontawesome-webfont.svg?v=4.7.0
// module id = 1068
// module chunks = 20